import { ConfigProvider, Segmented, SegmentedProps } from "antd";
import { useMemo } from "react";
import { useAntTheme } from "hooks/useAntTheme";

export const SegmentedButtons = <T extends string | boolean>(
  props: SegmentedProps<T>
) => {
  const { theme } = useAntTheme();
  // Keep the ConfigProvider theme object reference stable across renders —
  // a new object every render makes antd recompute and re-inject the
  // Segmented's styles (incl. the sliding highlight), which flickers when
  // this component re-renders repeatedly in quick succession (e.g. while a
  // request is in flight).
  const segmentedTheme = useMemo(
    () => ({
      components: {
        Segmented: {
          itemHoverColor: theme.colorPrimary,
        },
      },
    }),
    [theme.colorPrimary]
  );
  return (
    <ConfigProvider theme={segmentedTheme}>
      <Segmented<T>
        block
        {...props}
        style={{
          fontWeight: 600,
          ...props.style,
        }}
      />
    </ConfigProvider>
  );
};
